/**
 * Local (client-side) search over an already-loaded product list.
 * There is no API call here — it only narrows what the page already holds
 * in memory, so typing never blocks on the network.
 */

const DEFAULT_FIELDS = ["name", "desc", "code"];

export function normalizeQuery(query) {
  return query == null ? "" : String(query).trim().toLowerCase();
}

export function hasQuery(query) {
  return normalizeQuery(query) !== "";
}

/**
 * Every whitespace-separated term must appear somewhere in the searched
 * fields, so "bhog gold" matches a gold bhog item in any field order.
 * Returns the list untouched when the query is empty, and null stays null
 * so callers can keep using null as their "still loading" marker.
 */
export function filterProducts(products, query, fields) {
  const q = normalizeQuery(query);
  if (products == null || q === "") {
    return products;
  }

  const searchFields = fields != null ? fields : DEFAULT_FIELDS;
  const terms = q.split(/\s+/);

  return products.filter((product) => {
    const haystack = searchFields
      .map((field) => (product != null && product[field] != null ? String(product[field]) : ""))
      .join(" ")
      .toLowerCase();
    return terms.every((term) => haystack.indexOf(term) !== -1);
  });
}
